import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useOutletContext } from 'react-router-dom';

import { Button, Form } from 'antd';
import PhoneInput from 'antd-phone-input';
import css from '@/pages/Login/Login.module.scss';

import LoginWrapper from '@shared/pages/Login/LoginWrapper';
import { clearError, restoreMobileUser } from '@shared/store/Auth/actions';
import { selectAuth } from '@shared/store/Auth/selectors';
import { selectCompany } from '@shared/store/company/selectors';

const RecoveryMobile = () => {
  const dispatch = useDispatch();
  const [redirectPath, setRedirectPath] = useState('');

  const { error: errorText } = useSelector(selectAuth);
  const { company } = useSelector(selectCompany);

  const { isSending } = useOutletContext();
  const { t } = useTranslation(['login']);

  const handleSubmit = ({ phone }) => {
    const number = `+${phone?.countryCode}${phone?.areaCode}${phone?.phoneNumber}`;

    dispatch(
      restoreMobileUser({ phone: number, companyId: +company?.id }, resp => {
        localStorage.setItem('number', number);
        localStorage.setItem('companyId', company?.id);
        setRedirectPath(`/user-login/mobile-recovery/${resp.messageId}`);
      })
    );
  };

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  const mobileValidator = (_, { valid }) => {
    if (valid(true)) return Promise.resolve();
    return Promise.reject(t('rules.phone'));
  };

  const handleChange = (value, event) => {
    dispatch(clearError());
  };

  return (
    <LoginWrapper type='recover'>
      <Form className={css['LoginPage-form']} onFinish={handleSubmit}>
        <Form.Item
          className={css['LoginPage-form-item']}
          name='phone'
          validateTrigger='onBlur'
          validateStatus={errorText?.length > 0 ? 'error' : 'success'}
          help={errorText?.length > 0 && errorText}
          rules={[{ required: true, validator: mobileValidator }]}
        >
          <PhoneInput
            placeholder={t('placeholders.phone')}
            preferredCountries={['ru', 'by']}
            enableSearch
            disableParentheses
            onChange={handleChange}
          />
        </Form.Item>
        <Form.Item className={css['LoginPage-form-google']}>
          <Button size='large' type={'primary'} htmlType='submit' disabled={isSending}>
            {t('recovery')}
          </Button>
        </Form.Item>
      </Form>
    </LoginWrapper>
  );
};

export default RecoveryMobile;
